import { default as _Typography } from '@mui/material/Typography';
import type { TypographyProps as _TypographyProps } from '@mui/material/Typography';

export const Typography = _Typography;
export type TypographyProps = _TypographyProps;
